import React, { useContext, useState } from 'react';
import {useNavigate} from "react-router-dom";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Chip from '@mui/material/Chip';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';


import DivSpinner from "../../../components/divSpinner";
import { Context } from '../provider';
import ColumnSort from "./columnSort";
import { fullDateFormat } from '../../../utils';

const TableView = () => {
    let context = useContext(Context);

    return (
        <>
            {context.state.is_loading ? (
                <div style={{height : `${window.innerHeight-387}px`}}>
                    <DivSpinner/>
                </div>
            ) : (
                <div className="table-responsive p-0 m-3">
                    <TableContainer component={Paper}>
                        <Table aria-label="collapsible table" size={'small'}>
                            <TableHead>
                                <TableRow className='remedial-table-row'>
                                    {[
                                        'Job ID',
                                        'Tradesperson',
                                        'Customer',
                                        'Type',
                                        'Created Date',
                                        'Approved by Tradesperson',
                                        'Approved by Customer',
                                        'Recall Job Status'
                                    ].map((text, index) => (
                                        <TableCell 
                                            key={index} 
                                            align="center">
                                            <ColumnSort sortKeyName={text} />
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {context.state.recall_visits.length > 0 ? (
                                <>
                                    {context.state.recall_visits.map((item, index) => (
                                        <TableRow key={index}>
                                            {[
                                                item?.job?.job_id,
                                                item?.job?.ftm?.ftm_forename+' '+item?.job?.ftm?.ftm_surname,
                                                item?.job?.customer?.customer_full_name,
                                                <Chip 
                                                    label={item?.re_call_visit_paid_type === 1 ? "PAID" : "FREE"} 
                                                    color={item?.re_call_visit_paid_type === 1 ? "warning" : "default"}
                                                />,
                                                fullDateFormat(item?.re_call_visit_created_at),
                                                item?.re_call_visit_approval_by_ftm === 1 ?  <CheckCircleIcon color='success'/> : <CancelIcon color='error'/>,
                                                item?.re_call_visit_approval_by_customer === 1 ?  <CheckCircleIcon color='success'/> : <CancelIcon color='error'/>
                                            ].map((text, index) => (
                                                <TableCell align="center" key={index}>
                                                    <span className="text-secondary text-sm font-weight-bold">
                                                        {text}
                                                    </span>
                                                </TableCell>
                                            ))}
                                            <TableCell align="center">
                                                <i className="material-icons font-weight-bold" 
                                                    data-bs-toggle="tooltip" 
                                                    data-bs-placement="top"
                                                    title={item?.recall_job_status?.job_status_name}
                                                    style={{color: item?.recall_job_status?.job_status_color, fontSize: '30px', cursor: 'context-menu'}}
                                                >
                                                    {item?.recall_job_status?.job_status_icon}
                                                </i>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </>
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={8} align="center">Sorry, no data found!</TableCell>
                                </TableRow>
                            )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            )}
        </>
    );
}

export default TableView;